import RolesModel from '../Apis/Roles'
import Controller from './Controller'

export default class RolesController extends Controller {
  constructor() {
    super(new RolesModel())
  }
  async allPermission(params) {
    const data = await this.model.allPermission(params)
    return data
  }
}
